import React from "react";
import Button from "@amzn/meridian/button";
import LoaderBox from "../../../loader/LoaderBox";
import { ExpandedImageProps } from "./types";

export const ExpandedImage: React.FC<ExpandedImageProps> = ({
    expandedImage,
    isImageLoading,
    zoomLevel,
    handleCloseExpanded,
    handleZoom,
    setIsImageLoading,
}) => {
    if (!expandedImage) return null;

    return (
        <div className="expanded-image-overlay" onClick={handleCloseExpanded}>
            <div className="expanded-image-container" onClick={e => e.stopPropagation()}>
                {isImageLoading && <LoaderBox />}
                <img
                    src={expandedImage}
                    alt="Expanded view"
                    className="expanded-image"
                    style={{
                        transform: `scale(${zoomLevel})`,
                        display: isImageLoading ? "none" : "block",
                    }}
                    onLoad={() => setIsImageLoading(false)}
                />
                <div className="zoom-controls">
                    <Button onClick={() => handleZoom("out")} type="secondary">
                        -
                    </Button>
                    <Button onClick={() => handleZoom("reset")} type="secondary">
                        Reset
                    </Button>
                    <Button onClick={() => handleZoom("in")} type="secondary">
                        +
                    </Button>
                </div>
            </div>
        </div>
    );
};
